import { useEffect, useState } from 'react';
import LoadingIcon from "../../components/LoadingIcon/LoadingIcon";
import { SearchResultItemDt } from '../../Models/SearchModel';
import { notPublished } from '../../Api/Services/Search';
import styles from "../SearchPage/searchPage.module.css";
import SearchResult from "../SearchPage/SearchResult/SearchResult";

export default function NotPublished() {

  const [items, setItems] = useState<SearchResultItemDt[]>([]);
  const [loading, setLoading] = useState(true);
 
  useEffect(() => {
    setLoading(true);
    notPublished().then((requestData) => {
      setItems(requestData);
      setLoading(false);
    });
  }, []);

  return (
    <div className={`${styles.search_container} container`}>
      <h1>Not published</h1>
      {loading && <LoadingIcon />}
        <div className={styles.search_result_container}>
          {loading && <LoadingIcon />}
          {items.map((item, index) => (
            <SearchResult key={index} item={item} quality={item.alternativeLevel} />
          ))}
        </div>
    </div>
  );
}